<template>
  <div class="mb-memory">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
      }"
    />
    <div
      class="memory-box"
      :style="{
        width: startGameConfig.columns * (startGameConfig.width + 20) + 'px' || 200 + 'px',
      }"
      v-if="startGameConfig.type != 'findImage'"
    >
      <div
        :key="'mb-memory-field' + index"
        class="mb-memory-field"
        v-for="(fieldToSelect, index) in items"
        :style="{
          width: startGameConfig.width + 'px' || 200 + 'px',
          height: startGameConfig.height + 'px' || 200 + 'px',
        }"
      >
        <img
          v-if="fieldToSelect.image"
          :src="giveMeImagePlease(fieldToSelect.image.src)"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        />
        <transition name="memory-fade">
          <div
            class="memory-curtain"
            v-if="curtain[index].show"
            @click="changeCurtain(index)"
            :style="{
              width: startGameConfig.width + 'px' || 200 + 'px',
              height: startGameConfig.height + 'px' || 200 + 'px',
              background: startGameConfig.curtain || 'black',
            }"
          >
            <img
              v-if="startGameConfig.curtainImage"
              :src="giveMeImagePlease(startGameConfig.curtainImage.src)"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
            />
          </div>
        </transition>
      </div>
    </div>
    <div
      v-if="startGameConfig.type == 'findImage'"
      style="position: absolute"
      :style="{
        width: startGameConfig.imageToFind.width + 'px',
        height: startGameConfig.imageToFind.height + 'px',
        top: startGameConfig.imageToFind.pos.y + 'px',
        left: startGameConfig.imageToFind.pos.x + 'px',
      }"
    >
      <img
        :src="giveMeImagePlease(startGameConfig.imageToFind.src)"
        style="position: absolute; top: 0; width: 100%; height: 100%; left: 0"
      />
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
        <div
          :style="{
            position: 'absolute',
            cursor: 'pointer',
            top: field.top,
            left: field.left,
            width: field.width,
            height: field.height,
          }"
          :key="'curtain-img-' + indexImg"
          v-for="(field, indexImg) in fieldImg"
        >
          <transition name="memory-fade">
            <img
              :src="giveMeImagePlease(field.src)"
              style="width: 100%; height: 100%"
              v-if="field.index >= currentField"
              @click="checkField(field.index)"
            />
          </transition>
        </div>
      </div>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-memory',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      currentImg: -1,
      audio: null,
      status: false,
      canIPlay: true,
      items: [],
      curtain: [],
      openItem: [],
      fieldImg: [],
      currentField: 0,
      canICheck: true,
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
      canIClick: true,
    };
  },
  created() {},
  beforeMount() {
    if (this.startGameConfig.type != 'findImage') {
      this.init();
    } else {
      this.findImgInit();
    }
    if (this.startGameConfig.goodAudio) {
      this.setAudioConfig(this.startGameConfig.goodAudio, 1);
    }
  },
  mounted() {},
  methods: {
    checkSound(status) {
      if (status) {
        if (this.audioPositive) {
          if (this.canIPlayASong) {
            this.audioPositive.play();
          } else {
            this.audioPositive.stop();
            if (this.audioNegative) {
              this.audioNegative.stop();
            }
            this.audioPositive.play();
          }
        }
      } else {
        if (this.audioNegative) {
          if (this.canIPlayASong) {
            this.audioNegative.play();
          } else {
            this.audioNegative.stop();
            if (this.audioPositive) {
              this.audioPositive.stop();
            }
            this.audioNegative.play();
          }
        }
      }
    },
    checkField(index) {
      if (this.canICheck) {
        this.canICheck = false;
        console.log(index);
        console.log(this.currentField);
        if (this.currentField == index) {
          this.currentField++;
          this.checkSound(true);
        } else {
          this.currentField = 0;
          this.checkSound(false);
        }
        if (this.fieldImg.length == this.currentField) {
          this.$store.dispatch('checkGame');
        } else {
          setTimeout(() => {
            this.canICheck = true;
          }, 500);
        }
      }
    },
    checkGameAction() {
      if (this.startGameConfig.type != 'findImage') {
        if (this.curtain.every((x) => x.show == false)) {
          return true;
        } else return false;
      } else {
        if (this.fieldImg.length == this.currentField) {
          return true;
        } else return false;
      }
    },
    checkIndex() {
      if (this.items[this.openItem[0]].id == this.items[this.openItem[1]].id) {
        console.log('GOOOOOOD');
        this.checkSound(true);
        this.openItem = [];
        if (this.audio) {
          this.startAudio();
        }
        this.checkAllItems();
      } else {
        this.checkSound(false);
        console.log('BADDDDDD');
        this.curtain[this.openItem[0]].show = true;
        this.curtain[this.openItem[1]].show = true;
        this.openItem = [];
      }
    },
    checkAllItems() {
      if (this.curtain.every((x) => x.show == false)) {
        console.log('yeah!');
        this.$store.dispatch('checkGame');
      }
    },
    changeCurtain(index) {
      if (this.canIClick) {
        if (this.audioClick) {
          this.audioClick.play();
        }
        this.canIClick = false;
        if (this.openItem.length < 2) {
          if (this.openItem.length == 1 && !this.openItem[0] != index) {
            this.curtain[index].show = false;
            this.openItem.push(index);
          } else {
            this.curtain[index].show = false;
            this.openItem.push(index);
          }
          if (this.openItem.length == 2) {
            setTimeout(() => {
              this.checkIndex();
            }, 500);
          }
        }
        setTimeout(() => {
          this.canIClick = true;
        }, 500);
      }
    },
    findImgInit() {
      let item = this.startGameConfig.curtainImages;
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
      this.shuffle(item);
      let y = 0;
      let x = 0;
      for (let i = 0; i < item.length; i++) {
        this.fieldImg.push({
          width: 100 / this.startGameConfig.columns + '%',
          height: 100 / this.startGameConfig.rows + '%',
          top: (100 / this.startGameConfig.rows) * y + '%',
          left: (100 / this.startGameConfig.columns) * x + '%',
          src: item[i].src,
          index: item[i].index,
        });
        y++;
        if (y == this.startGameConfig.columns) {
          x++;
          y = 0;
        }
      }
      console.log(this.findImg);
    },
    init() {
      this.items = this.startGameConfig.fields;
      this.shuffle(this.items);
      this.items.forEach((el) => {
        this.curtain.push({ show: true });
      });
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
    },
    imageSetStyle(currentImg, index, imgToSelect) {
      return (
        currentImg == index && this.startGameConfig.imageHighlight != false
          ? {
              filter: 'drop-shadow(0 0 40px ' + imgToSelect.imageHighlightColor + ')',
            }
          : {},
        imgToSelect.cssStyle
      );
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onplay: () => {
          this.canIPlayASong = false;
        },
      });
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    setImg(index, audio) {
      if (this.canIPlay) {
        if (this.currentImg != -1 && this.audio != null) {
          this.stopAudio();
        }
        if (audio) {
          this.setAudioConfig(audio.src, audio.volume);
        }
        this.currentImg = index;
        this.canIPlay = false;
        setTimeout(() => {
          this.canIPlay = true;
        }, 500);
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.audio = null;
      this.status = false;
      this.canIPlay = true;
      this.items = [];
      this.curtain = [];
      this.openItem = [];
      if (this.startGameConfig.type != 'findImage') {
        this.init();
      } else {
        this.fieldImg = [];
        this.currentField = 0;
        this.findImgInit();
        this.canICheck = true;
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    toBase64(index) {
      let elem = this.$refs['signaturePad-' + index];
      return elem[0].saveSignature().data;
      //console.log(elem[0].saveSignature().data);
    },
  },
  destroyed() {
    if (this.currentImg != -1) {
      this.stopAudio();
    }
  },
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-memory,
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .memory-box
    .mb-memory-field
      display: inline-block
      margin: 5px
      cursor: pointer
      position: relative
      .memory-curtain
        position: absolute
        top: 0

.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
